import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";
import Carousel from "react-elastic-carousel";
import WaveSurfer from "wavesurfer.js";
import { peaks } from "./peaks.js";
import { base_url } from "../Model/config";
import ClapprWrapper from "../Utils/clapprreplay";
import ReactGA from "react-ga";
import "../Header/css/app.css";
import "../Header/css/theme.css";
import "../Header/css/custom.css";
import "../Header/css/font-awesome.min.css";
import "../Header/layerslider/css/layerslider.css";
import "../Header/css/owl.carousel.min.css";
import "../Header/css/owl.theme.default.min.css";
import "../Header/css/responsive.css";
import "../Header/css/custom-responsive.css";
import rts1hdsmall from "../Header/images/rts/rts1hdsmall.png";
import rts2hdsmall from "../Header/images/rts/rts2hdsmall.png";
import rts3hdsmall from "../Header/images/rts/rts3hdsmall.png";
import rts4hdsmall from "../Header/images/rts/rts4hdsmall.png";
import m1g from "../Header/images/play.png";
import rsismall from "../Header/images/rts/rsismall.png";
import logosmall from "../Header/images/logo-small.png";
import rtslogo from "../Header/images/rts-logo.png";
import playbutton from "../Header/images/play-button.png";
import programmain from "../Header/images/program-main.jpg";
import progressbar from "../Header/images/progressbar.jpg";
import iosappstore from "../Header/images/ios-app-store.png";
import googleplaystore from "../Header/images/google-play-store.png";
import programmainv2 from "../Header/images/program-main-v2.jpg";
import jellbii from "../Header/images/jell-bii.jpg";
import dmedia from "../Header/images/rts/larts.png";

class RadioPage extends Component {
  state = {
    emissions: [],
    radios: [],
    oneemissions: [],
    videos: [],
    tvs: [],
    min: 0,
    max: 3,
    max1: 6,
    url: "",
    srctv: "",
    title: "",
    desc: "",
  };
  async componentDidMount() {
    ReactGA.initialize("UA-100085590-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    window.location.href = "#";
    axios.get(base_url + "listLiveRadios/larts/json").then((res) => {
      const radios = res.data;
      this.setState({
        radios,
        srctv: radios.allitems[0].stream_url,
        title: radios.allitems[0].title,
        desc: radios.allitems[0].desc,
      });
    });
    // axios.get(base_url + "listLiveTV/eutelsat/json").then((res) => {
    //     const tvs = res.data;
    //     this.setState({ tvs });
    // });
    const aud = document.querySelector("#song");
    await this.setState({ aud });

    this.wavesurfer = WaveSurfer.create({
      barWidth: 4,
      cursorWidth: 1,
      container: "#waveform",
      normalize: true,
      backend: "MediaElement",
      height: 80,
      progressColor: "#4a74a5",
      responsive: true,
      waveColor: "#971B25",
      cursorColor: "transparent",
    });

    await this.wavesurfer.load(aud, peaks);
  }
  handleClick1 = (url, titre, description, e) => {
    e.preventDefault();

    this.setState({ srctv: url, title: titre, desc: description });
  };
  playIt = () => {
    this.wavesurfer.playPause();
    // this.OnToPlay();
    if (this.state.aud == undefined) {
      alert("audio non trouvé");
    } else if (this.state.aud != "" && this.state.aud.paused) {
      var img = document.getElementById("pausePlay");
      if (img) {
        img.src =
          "data:image/png;base64,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";
      }
    } else {
      var img = document.getElementById("pausePlay");
      if (img) {
        img.src =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsSAAALEgHS3X78AAAEw0lEQVR4nO2cT2gcVRzHv6Y2zT/JJmINBGxOerColUILIzT+OXiRqZdWTyoezEFwTXvwYHVLofRgY7dUiKCQnrRezHjqQdsUHKgnbelFEKxCcVsx2aFNkwbayHdnkt2ZN/93ZmfnzwcC4e2byft9eO/N7723mYfW19dR4EyP4ycFDR5OXMPRmZfR0/OYUE4ePPgXn07/JJR3kM4OsWOn3sC23lfRt20v+vt2YMuWPqGOHffvr2Jl9S+s3ruMe2vncaT8rU2tWIhf0PHTn2Bw4DU8MrRb+CwsFHZ35RpuL8/h4w++SJ+gyslnMNA/jZHhg757SVgoa0k7h7srM6gcuhr17aMVVDn5OIYGZzFa2i981gkW6/O4szyFyqGbUf216ASdOPM5Hh2Zir3HeMEe9d/SLD56/0OPmr5oXxCH02jpOwwNPiV8liR3ln/HYv1Au8OuvTyIE/D42C9dJ4ewTWwb29gG4XvQZ7PfJzbXBIVz0+Gp18NcGk7QzJcXUBp+USjvZuraRUy/91LQFgYfYmmUQ9hmtj0gwQSlVc4GIST5F8Q5J81yNmAMjMUn/gTxSZCWCdkPjMXn0817kmaew8dl0glg1DChvFHb45UnefcgJoFZk0MYE2PzwF0Qlw/dmARGBWNjjC44DzEuPMfHrmey97SiD7UJpwWucw/iqjzrcmAMNcbqgH0P4sT8xPgVoTzL/H3jWbsJ274HcbMrbzjEbC+IO4F5wyFmURATqDzMPVYYs03yKAriBntesYldPBeL8vTBSm8v8MoLwNh27vgBP/4MLC4J1UyMjujXDA0CtVv6NWtrQrVIGOjfab2NuQfx3CpOnn5SlwPoAe/d5f3Hnt+p1yW8lveICw4ziwOzIB7qdRu9WzvbIIsDsyCeeOYdiwOzIB4H5x2LA7OgPD7erVgcNAXxWxYFgoumIKevoOSRFhdiolhgohDkQTOTPn+x5l41At59E9jVkqz+cwv4+hv3+7L+RnJJfr3mfU371HCk3LhJ0YM8KAR50Cqo7l41V2y6aApSld/ybmWTFhfWIaYJlfOHyYFVUNGLLA6sghaE6vnD5CBZQdxV7D5cBKnKQqzz0Lkf9ESP1HwkiaT6FfDHn/rvvJb3iA/NcLCJeHAoyfMA5Dhb0cUoUBXT13zsEsV5oSQ/zFkjFXsQGr2IidKwUJ5tOLxK1gjtehA5JZRkH9uYnQQJXa0Q1IqqXOfzQyjPLlWoiu1a1F6QTiUnSw/NiNUWZ0G6UccLM0TFqffA8SnWiiQzcdonlGeDS1CVSbdInHtQk7czOtQ0IzZXvAXpE3ZZKE8/ZSM2V/xtuarKXMaealUjJk+C/TuUJPOmbwnl6eIsVMVzaG0QbNNev/FZoTw9BJKDUKca6ZUUWA5CH/vofyhNc1I1jBy0dS6mKnyyvdPlKYDWaKPe1lC0/2/hkjxhLG67LZm81MhzfDzK3YjuxQKSXDaWJknvI2nG8sF2dR6U6I6e9QZNJDw3VRttiEgOYnu5iSSXjOy73IEepRl7OXPtDic74n89jiTvN9Y8kxHK0ozjGUqJdQ+9sy9YkuRJQxR/ngsgTDNOPBcaP5ajmThJ/iVvkkxRwma5QT3pL1UUb8HzoPgClRsA/gc6l4OTzo9K3gAAAABJRU5ErkJggg==";
      }
    }
  };
  OnToPlay() {
    if (this.state.aud != "" && this.state.aud.paused) {
      return (
        <img src={m1g} alt="" id="pausePlay" srcset="" onClick={this.playIt} />
      );
    } else {
      var img = document.getElementById("pausePlay");
      if (img) {
        img.src = "/static/media/zikfm.5508f51f.png";
      }
    }
  }
  handleClick = (url, title, e) => {
    e.preventDefault();
    this.setState({ urplay: url, titre: title });
    this.playIt();
  };
  render() {
    const radios = this.state.radios.allitems;
    const tvs = this.state.tvs.allitems;
    const oneemissions = this.state.oneemissions.allitems;
    const videos = this.state.videos.allitems;
    return (
      <div>
        <br />
        <div className="row">
          <div style={{ width: "100%", height: 80 }} id="waveform" />
          <audio
            id="song"
            src={this.state.srctv}
            controls={true}
            autoPlay={true}
            style={{ display: "none" }}
          />
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 style={{ textAlign: "center" }}>
              <img
                src={m1g}
                alt=""
                id="pausePlay"
                style={{ height: "80px" }}
                onClick={this.playIt}
              />
            </h4>
          </div>
          {/* <div className="col-md-12">
                        <h4 style={{ textAlign: "center" }}>
                            <a
                                href=""
                                onClick={(e) => this.handleClick(this.state.srctv, this.state.title, e)}
                                style={{ color: "white" }}
                            >
                                <span style={{ backgroundColor: "#C83304", borderRadius: "5px" }}>Ecoutez WalfFM en direct </span>
                            </a>
                        </h4>
                    </div> */}
        </div>
        <br />
        <h4
          style={{ color: "#C83304", fontWeight: "bold", textAlign: "center" }}>
          Vous écoutez {this.state.title}
        </h4>
        <br />

        <section id="category" className="video-new-carousel">
          <div className="row secBg">
            <div className="large-12 columns">
              <div className="column row">
                <div className="navText pull-right">
                  <a className="prev">
                    <i className="fa fa-angle-left" />
                  </a>
                  <a className="next">
                    <i className="fa fa-angle-right" />
                  </a>
                </div>
              </div>
              <div
                id="owl-demo-cat"
                className="owl-carousel carousel owl-theme owl-responsive--1 owl-loaded"
                data-car-length={5}
                data-items={5}
                data-loop="true"
                data-nav="false"
                data-autoplay="true"
                data-autoplay-timeout={4000}
                data-auto-width="true"
                data-margin={25}
                data-dots="false">
                <div className="owl-stage-outer">
                  <div
                    className="owl-stage"
                    style={{
                      transform: "translate3d(0px, 0px, 0px)",
                      transition: "all 0.25s ease 0s",
                      width: "1045px",
                    }}>
                    {radios ? (
                      radios.map((radio, i) => (
                        <div
                          className="owl-item active"
                          style={{ width: "auto", marginRight: "25px" }}>
                          <div className="item-cat item">
                            <figure className="premium-img">
                              <img
                                src={radio.sd_logo}
                                onError={(e) => {
                                  e.target.src = dmedia;
                                  e.target.onError = null;
                                }}
                                alt=""
                              />
                              <a
                                href="#"
                                onClick={(e) =>
                                  this.handleClick1(
                                    radio.stream_url,
                                    radio.title,
                                    radio.desc,
                                    e
                                  )
                                }
                                className="hover-posts">
                                <span>
                                  <i className="fa fa-play" />
                                </span>
                              </a>
                            </figure>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-md-10 text-center">
                        (
                        <Loader
                          type="ThreeDots"
                          color="#971B25"
                          height={10}
                          width={60}
                          visible={true}
                        />
                        )
                      </div>
                    )}
                  </div>
                </div>
                <div className="owl-controls">
                  <div className="owl-nav">
                    <div className="owl-prev" style={{ display: "none" }}>
                      prev
                    </div>
                    <div className="owl-next" style={{ display: "none" }}>
                      next
                    </div>
                  </div>
                  <div className="owl-dots" style={{ display: "none" }} />
                </div>
              </div>
              {/* end carousel */}
            </div>
          </div>
        </section>

        <div className="googleAdv">
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-6275124887475376"
            data-ad-slot={2326453444}
            data-ad-format="auto"
          />
        </div>
      </div>
    );
  }
}

export default RadioPage;
